import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { ScreenPickerProps, ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { AddDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { SubstanceConversionFactor } from 'app/area/codetable/item/types-store';
import { DocumentItemFromMultiSelect } from 'app/components';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
export interface UomConversionTypeProps extends ScreenPickerProps {
  existingKeys: CodeComplexValue<number>[];
}

export const UoMConversionType = (props: UomConversionTypeProps) => {

  const { breadcrumbs, updateByKey, codetableOptions, loadCodetableOptions, existingKeys = [], codeItem, translation } = props;

  const codetableId = codetableOptionsIds[ScreenPicker.uomConversionType];

  const onLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(ScreenPicker.uomConversionType, codetableId, {
      ...loadOptionsParams,
      limitFieldsTo: []
    });
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableOptionsIds.uomConversionType, breadcrumbs);

  const createNewConversionFactor = (_: boolean, options?: AddDocumentItemOptions[]) => {

    const newSubstanceConversionFactors = options.map<SubstanceConversionFactor>(option => {
      const rawNewConversionFactor = option?.initialValues?.primaryKey as CodeComplexValue<number>;

      if (!(rawNewConversionFactor && isDefinedIncludingZero(rawNewConversionFactor.value) &&
        isDefinedIncludingZero(rawNewConversionFactor.uomTypeFrom) && isDefinedIncludingZero(rawNewConversionFactor.uomTypeFrom))) {
        return undefined;
      }

      return {
        uomConversionType: {
          value: rawNewConversionFactor.value,
          description: rawNewConversionFactor.description
        },
        uomTypeFrom: rawNewConversionFactor.uomTypeFrom,
        uomTypeTo: rawNewConversionFactor.uomTypeTo,
        uomTo: undefined,
        uomFrom: undefined,
        factor: undefined
      };
    }).filter(option => option);

    const allSubstanceConversionFactors = [...(codeItem.substanceConversionFactor || []), ...newSubstanceConversionFactors];
    updateByKey(ScreenPicker.substanceConversionFactor, allSubstanceConversionFactors);
  };

  const codeOptions = codetableOptions?.[ScreenPicker.uomConversionType]?.codes || [];

  const fetching = codetableOptions?.[ScreenPicker.uomConversionType]?.fetching;

  const notPickedOptions = (options: CodeComplexValue<number>[]): CodeComplexValue<number>[] =>
    existingKeys.filter(c => options.findIndex(key => key.value === c.value) < 0)
      .map(element => ({
        ...element,
        ...(!!element.descendants && { descendants: notPickedOptions(element.descendants) })
      }));

  return <DocumentItemFromMultiSelect
    fetching={fetching}
    categoryId={undefined}
    existingKeys={existingKeys}
    onAddDocumentItems={createNewConversionFactor}
    options={codeOptions}
    textAddItem={translation.add_conversion_factor}
    placeholderSearch={translation.search}
    textCodeSelectorTitle={translation.add_conversion_factor}
    textDone={translation.done}
    onLoadOptions={onLoadOptions}
    extraFooterButton={extraFooterButton}
    displaySelectAll={true}
    canHideSearchInput={existingKeys.length > 0 && notPickedOptions(codeOptions)?.length === 0}
  />;
};
